export default __webpack_public_path__ + "static/media/image9.d503f9d9.jpg";